import {h, Fragment} from "preact"
import { AutocompleteElement, Keywords } from "@nosto/preact"

export default function KeywordsBlock({keywords, popularKeywords}) {
    return (
        <div class={`ns-autocomplete-keywords ns-d-flex ns-flex-column`}>
            {keywords?.length > 0 ? (
                <>
                    <div class="left_top_title font-secondary mono-xsm">
                        Top Suggestions
                    </div>
                    <div class="ns-autocomplete-elements">
                        <Keywords
                            hits={keywords}
                            keywordComponent={Keyword}
                            elementComponent={Element}
                            keywordInCategoryComponent={KeywordInCategory}
                        />
                    </div>
                </>
            ) : null}
            {popularKeywords?.length > 0 ? (
                <>
                    <div class="left_top_title font-secondary mono-xsm">
                        Popular Searches
                    </div>
                    <div class="ns-autocomplete-elements">
                        <Keywords
                            hits={popularKeywords}
                            keywordComponent={Keyword}
                            elementComponent={Element}
                            keywordInCategoryComponent={KeywordInCategory}
                        />
                    </div>
                </>
            ) : null}
        </div>
    )
}

function Keyword({ hit }) {
    return (
        <span data-nosto-element="keyword" data-element="popular-search">
            {hit?._highlight?.keyword ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword
                    }}
                ></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

function Element({ hit, keywordComponent, filter }) {
    return (
        <AutocompleteElement hit={hit} filter={filter} class="ns-clickable mono-xsm md-mono-sm font-secondary">
            {keywordComponent}
        </AutocompleteElement>
    )
}

function KeywordInCategory({ category, children }) {
    return (
        <span class="ns-clickable">
            {category?.value ? (
                <span>
                    {children}{" "}
                    <span class="ns-keyword-in-category">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}